export default {
    calendar:    'calendar',
    check:       'check',
    cross:       'cross',
    minusCircle: 'minusCircle',
    plusCircle:  'plusCircle',
};